<mat-card>
  <app-card-header
    [title]="title"
    [icono]="fechaAlta ? 'add_photo_alternate' : 'event_available'"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close(false)"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <app-content-card title="Fecha de alta" icon="event">
      @if (!fechaAlta) {
        <!-- Selector de fecha mientras el alta no está cargada -->
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>Fecha de alta</mat-label>
            <input
              readonly
              matInput
              [owlDateTime]="dt1"
              [selectMode]="'single'"
              (dateTimeChange)="onDateTimeChange($event)"
              [max]="maxDate"
            />
            <button
              irxBotonIcono
              tooltip="Elegir fecha"
              matSuffix
              [owlDateTimeTrigger]="dt1"
              type="button"
            >
              <mat-icon>calendar_month</mat-icon>
            </button>
          </mat-form-field>
          <owl-date-time #dt1></owl-date-time>
        </section>
      } @else {
        <div class="dav-dato">
          <span class="dav-etiqueta">Fecha de alta</span>
          <span class="dav-valor">
            {{ fechaAlta | date: 'dd/MM/yyyy HH:mm' }}
          </span>
        </div>
      }
    </app-content-card>

    <app-content-card title="Imágenes" icon="photo_library">
      <app-upload-file
        [(urls)]="urlImagenes"
        textoBoton="Subir Imágenes"
        [allowMultiple]="true"
        [maxFiles]="4"
      ></app-upload-file>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="dialogRef.close(false)"
    >
      Cancelar
    </button>
    @if (fechaAlta) {
      <button
        irxBoton="principal"
        type="button"
        (click)="onSubmit()"
        [disabled]="loading"
      >
        <mat-icon>check</mat-icon>
        Actualizar
      </button>
    } @else {
      <button
        irxBoton="principal"
        type="button"
        (click)="onSubmit()"
        [disabled]="!selectedFechaAlta || loading"
      >
        <mat-icon>event_available</mat-icon>
        Dar de alta
      </button>
    }
  </mat-card-actions>
</mat-card>
